export const MessagingTypes: IMessagingType[] = [
  // {name: "Emails", value: "EMAIL", description: "Targeted emails sent"},
  {name: "InApp Notifications", value: "APP", description: "In-App notifications pushed"},
  // {name: "SMS", value: "SMS", description: "Mobile SMS Sent"},
]

export const MessagingSize: IMessagingSize[] = [
  {name: "Single", value: "SINGLE", description: "Targeted messages sent to single recipient"},
  {name: "Bulk", value: "BULK", description: "Targeted messages sent to multiple recipient"},
]